import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("bevela_lang") || "es");
  useEffect(() => {
    localStorage.setItem("bevela_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = translations[lang] || translations.es;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
